import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // בדיקה אם המשתמש כבר אישר בעבר
    const consent = localStorage.getItem('cookie-consent-driver');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent-driver', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.banner}>
        <div style={styles.textContent}>
          <p style={styles.text}>
            אנחנו משתמשים בעוגיות כדי לשפר את חווית הגלישה שלך, להציג מודעות מותאמות אישית 
            ולנתח את התנועה באתר שלנו. למידע נוסף, קרא את 
            <a href="/privacy" style={styles.link}>מדיניות הפרטיות</a> שלנו.
          </p>
        </div>
        <div style={styles.actions}>
          <button onClick={handleAccept} style={styles.button}>
            אני מאשר/ת
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '90%',
    maxWidth: '600px',
    zIndex: 9999,
  },
  banner: {
    backgroundColor: '#ffffff',
    color: '#1e293b',
    padding: '20px',
    borderRadius: '16px',
    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
    border: '1px solid #e2e8f0',
    direction: 'rtl',
  },
  textContent: {
    textAlign: 'center',
  },
  text: {
    margin: 0,
    fontSize: '0.95rem',
    lineHeight: '1.5',
  },
  link: {
    color: '#3b82f6',
    textDecoration: 'underline',
    marginRight: '5px',
  },
  actions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    backgroundColor: '#1e3a8a',
    color: 'white',
    border: 'none',
    padding: '10px 30px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '600',
    transition: 'background-color 0.2s',
  },
};

export default CookieConsent;